// extracted by mini-css-extract-plugin
export default {"container":"TableUpdateDevicesActionCell_container__854K+","content":"TableUpdateDevicesActionCell_content__9j2-G"};